import React from "react";
import CircleLoading from "./CircleLoading";
import {BLUE_SQUARE_BOX} from "../../_presentational/buttons";

/*
    props
    button_text : string
    on_click : func(return void) = validate 체크
    margin_top : string = default 2.5em
    is_loading : bool
 */
const SubmitButton = (props) => {
    return (
        <div onClick={() => props.on_click()} style={{marginTop: props.margin_top || "2.5em"}}>
            <BLUE_SQUARE_BOX>
                {props.is_loading ? <CircleLoading size={"sm"} /> : <span>{props.button_text}</span>}
            </BLUE_SQUARE_BOX>
        </div>
    );
};

export default SubmitButton;
